import React from 'react';
import { 
  Search as SearchIcon,
  Sort as SortIcon,
  Clear as ClearIcon
} from '@mui/icons-material';
import './styles/MobileClients.css';

const MobileClientSearchHeader = ({ 
  searchTerm, 
  onSearchChange, 
  onSortClick,
  totalClients = 0,
  listMode = 'active',
  onListModeChange,
}) => {
  const isArchivedView = listMode === 'archived';

  return (
    <div className="mobile-clients-search-header">
      <div className="mobile-clients-search-header__top">
        <h2 className="mobile-clients-title">Clients</h2>
        <span className="mobile-clients-count-pill">
          {totalClients} {isArchivedView ? 'archived' : 'total'}
        </span>
      </div>

      <div className="mobile-clients-list-mode">
        <button
          type="button"
          className={`mobile-clients-list-mode-btn${listMode === 'active' ? ' is-active' : ''}`}
          onClick={() => onListModeChange?.('active')}
        >
          Active
        </button>
        <button
          type="button"
          className={`mobile-clients-list-mode-btn${listMode === 'archived' ? ' is-active' : ''}`}
          onClick={() => onListModeChange?.('archived')}
        >
          Archived
        </button>
      </div>

      <div className="mobile-clients-search-bar">
        <div className="mobile-clients-icon-button">
          <SearchIcon fontSize="small" />
        </div>
        <input
          className="mobile-clients-search-input"
          type="text"
          placeholder={isArchivedView ? 'Search archived clients...' : 'Search clients...'}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {searchTerm && (
          <button
            type="button"
            className="mobile-clients-icon-button"
            onClick={() => onSearchChange('')}
            aria-label="Clear search"
          >
            <ClearIcon fontSize="small" />
          </button>
        )}
        <button
          type="button"
          className="mobile-clients-icon-button"
          onClick={onSortClick}
          aria-label="Sort clients"
        >
          <SortIcon fontSize="small" />
        </button>
      </div>
    </div>
  );
};

export default MobileClientSearchHeader;
